import { render, staticRenderFns } from "./AColorPicker.vue?vue&type=template&id=3bb6a917"
import script from "@/components/AColorPicker/AColorPicker.ts?vue&type=script&lang=ts&external"
export * from "@/components/AColorPicker/AColorPicker.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports